import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';
import { queryClientTwins } from '../../../clientTwins';
import router from '../../../router/router';

let localSubscription = undefined;

async function createSubscription(store, clientId) {

	const all_clients = await queryClientTwins(clientId);
	if (!all_clients) {
		// Delete elsewhere, nothing left to subscribe here.
		return;
	}

	let goalQuery = new Parse.Query('Goal');
	goalQuery.limit(1000000)

	goalQuery.notEqualTo("deleted", true)
	goalQuery.descending("createdAt")
	goalQuery.containedIn("client", all_clients)

	// var clientPointer = {
	// 	__type: 'Pointer',
	// 	className: 'Client',
	// 	objectId: clientId
	// }

	goalQuery.find()
		.then((results) => {
			store.dispatch('goals/set', results)
		})
		.catch((error) => {
			handleParseError(error);

		});

	goalQuery.subscribe().then((subscription) => {

		localSubscription = subscription

		subscription.on('create', object => {

			store.dispatch('goals/insert', object)
		});
		subscription.on('update', object => {

			store.dispatch('goals/replace', object)
		});
		subscription.on('enter', object => {

			store.dispatch('goals/insert', object)
		});
		subscription.on('leave', object => {

			store.dispatch('goals/delete', object)
		});
		subscription.on('delete', object => {

			store.dispatch('goals/delete', object)
		});
		subscription.on('close', () => {

		});
		subscription.on('error', error => {

		})
	})
}


export default function createGoalSubscription() {
	return store => {
		store.subscribe(mutation => {
			if (mutation.type === 'clients/SET_FOCUSED_CLIENT_ID' && (router.currentRoute.name == "Goal" || router.currentRoute.name == "GoalDetail" ||
				router.currentRoute.name == "GoalEdit" || router.currentRoute.name == "GoalInput" || router.currentRoute.name == "GoalRating")) {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if(mutation.payload)
				{
					createSubscription(store, mutation.payload)
				}
				
			}
		}),
		store.subscribe(mutation => {
			if (mutation.type === 'ADD_LAST_ROUTE' && (router.currentRoute.name == "Goal" || router.currentRoute.name == "GoalDetail" ||
			router.currentRoute.name == "GoalEdit" || router.currentRoute.name == "GoalInput" || router.currentRoute.name == "GoalRating")) {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if (store.state.clients.focusedClientId) {
					
					createSubscription(store, store.state.clients.focusedClientId)
				}
			}
		})
	}
}
